module.exports = __webpack_public_path__ + "img/sjm.ae547dbe.svg";